module.exports = __webpack_public_path__ + "static/media/3_armies.1702c1b7.png";